export default "<div>\n    <div class=\"w3-section\">\n        <div data-dojo-attach-point=\"tableContainer\"></div>\n    </div>\n</div>\n"